import { Fragment } from 'react';
import { gray } from '../../../components/Color';
import FlexGrid, { FlexGridColumn } from '../../../components/FlexGrid';
import { MovingGradient } from '../../../components/MovingGradient';
import Typography from '../../../components/Typography';
import { useTranslationAPI } from '../../translations';
import { getRandomBoundary } from '../../list/listPage/ListLoadingPlaceholder/utils';

function AllJobsListLoadingPlaceholderItems() {
	return (
		<>
			{Array.from(Array(2).keys()).map((category) => {
				const categoryTitleWidth = getRandomBoundary(60, 180, 'px');
				const itemsCount = Math.round(Math.random() * (18 - 7) + 7);

				return (
					<Fragment key={category}>
						<MovingGradient
							height='20px'
							width={categoryTitleWidth}
						/>

						<div
							style={{
								columnCount: 3,
								columnWidth: '288px',
								columnGap: '48px',
							}}
						>
							{Array.from(Array(itemsCount).keys()).map((item) => {
								const itemWidth = getRandomBoundary(50, 280, 'px');

								return (
									<FlexGrid
										key={item}
										spaceBetween
										gap='tiny'
										style={{
											height: '40px',
											lineHeight: '40px',
											borderBottom: '1px solid var(--oc-gray-5)',
										}}
										center
									>
										<FlexGridColumn
											style={{
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
											}}
										>
											<MovingGradient
												width={itemWidth}
												height='17px'
											/>
										</FlexGridColumn>
										<FlexGridColumn>
											<Typography
												color={gray[6]}
												style={{
													whiteSpace: 'nowrap',
												}}
											>
												0
											</Typography>
										</FlexGridColumn>
									</FlexGrid>
								);
							})}
						</div>
					</Fragment>
				);
			})}
		</>
	);
}

function AllJobsListLoadingPlaceholder() {
	const { translate } = useTranslationAPI();

	return (
		<FlexGrid
			style={{
				width: '100%',
				maxWidth: 'min(1600px, calc(100% - 2 * 32px))',
				margin: '32px auto',
				boxSizing: 'border-box',
			}}
			column
			gap='medium'
		>
			<Typography
				bold
				fontSize='38px'
				headingSize={2}
				color={gray[6]}
			>
				{translate(4206)}
			</Typography>
			<AllJobsListLoadingPlaceholderItems />
		</FlexGrid>
	);
}

export { AllJobsListLoadingPlaceholder, AllJobsListLoadingPlaceholderItems };
